let $ = jQuery;
function addButtonScrollToTop() {
    if ($(this).scrollTop() > 300){
        $('.scroll-to-top').fadeIn();
    }else {
        $('.scroll-to-top').fadeOut();
    }
}
function scrollToTop(event) {
    event.preventDefault();
    $('html, body').animate({
        scrollTop: $('body').offset().top,
    }, 500);
}

function scrolltoID() {
    let id = $(this).attr('href');
    if (id.length && $(id).length){
        $('html, body').animate({
            scrollTop: $(id).offset().top,
        }, 500);
    }
}

export function scrollTo(){
    //scroll to Top
    $(window).scroll(addButtonScrollToTop);
    $(document).on('click', '.scroll-to-top', scrollToTop);

    //scroll to ID
    $(document).on('click', '.scroll-to-id', scrolltoID);

    //sticky sidebar
    if ($('.theia-sticky-content').length && $('.theia-sticky-sidebar').length){
        $('.theia-sticky-content, .theia-sticky-sidebar').theiaStickySidebar({
            additionalMarginTop: 50,
            additionalMarginBottom: 5,
        });
    }

    if ($('.um-account-side').length && $('.um-account-main').length){
        $('.um-account-side, .um-account-main').theiaStickySidebar({
            additionalMarginTop: 70,
            additionalMarginBottom: 5,
        });
    }
}